module.exports = __webpack_public_path__ + "static/media/ruler-combined.537b2494.svg";